import { usePermanentLocations } from "components/DealersAndLocationsDropdown/hooks";
import { CarsLeadsFilters, CarsLeadsTable } from "modules/LeadsDashboard/Leads/CarsLeads/components";

export const CarsLeads = () => {
  const { locations } = usePermanentLocations();

  return (
    <>
      <CarsLeadsFilters />
      <CarsLeadsTable locations={locations} />
    </>
  );
};
